import React from 'react';

function Challenge() {
  return (
    <section className="section-padding">
      <div className="container">
        <div className="info mb-80 pb-20 bord-thin-bottom">
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <div className="item mb-30">
                <span className="opacity-8 mb-5">Category :</span>
                <h6>Cleaning Services</h6>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="item mb-30">
                <span className="opacity-8 mb-5">Services offered :</span>
                <h6>Kitchen, Bathroom Cleaning</h6>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="item mb-30">
                <span className="opacity-8 mb-5">Date :</span>
                <h6>25th July 2024</h6>
              </div>
            </div>
            
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row">
              <div className="col-lg-5">
                <h4 className="mb-50">01 . Service Highlights</h4>
              </div>
              <div className="col-lg-7">
                <div className="text">
                  <h5 className="mb-30 fw-400 line-height-40">
                  Our deep cleaning services cover every detail to make your space shine. In the kitchen, we clean cabinets, countertops, and appliances while removing grease and odors. Bathrooms are thoroughly sanitized, including tiles, mirrors, and fixtures, leaving them sparkling and disinfected. For your home, we dust and vacuum furniture, clean windows and doors, and ensure every surface is spotless using safe, eco-friendly cleaning solutions.
                  </h5>
                  {/* <p className="fz-18">
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which
                    don&apos;t look even slightly believable. If you are going
                    to use a passage of Lorem Ipsum, you need to be sure there
                    isn&apos;t anything embarrassing hidden in the middle of
                    text.
                  </p> */}
                </div>
              </div>
            
              
            </div>
          </div>
        </div>
        
      </div>
    </section>
  );
}

export default Challenge;
